export default __webpack_public_path__ + "static/media/dl-bg.d5633085.jpg";